import React, { useState, useEffect, useContext } from "react";
import { BlackAndWhite } from "../../../../themes/Colors";
import QuestionButton from "./components/button/QuestionButton";
import {
  BaseButtons,
  CloseButton,
  TextAreaInput,
  TextInputField,
} from "../../../../components/atoms";

import { AuthContext } from "../../../../context/auth-context";

import Consent from "./components/consent/Consent";
import useWindowDimensions from "../../../../components/get-diemensions/UseWindowDiemensions";
import StoreSelector from "./components/store-selector/StoreSelector";
import { LoadingPopUp, ToastNotification } from "../../../../components";

const MedicalHistory = ({}) => {
  const { width, height } = useWindowDimensions();
  const [section, setSelectedSection] = useState("none");
  const [data, setData] = useState(null);
  const [lifeStyle, setLifeStyle] = useState(false);
  const [medicalHistory, setMedicalHistory] = useState(false);
  const [occupationalDetails, setOccupationalDetails] = useState(false);
  const [consent, setConsent] = useState(false);
  const [lifeStyleInfo, setLifeStyleInfo] = useState(null);
  const [occupationaleInfo, setOccupationalInfo] = useState(null);
  const [medicalInfo, setMedicalInfo] = useState(null);

  const [errorMessage, setErrorMessage] = useState(null);
  const auth = useContext(AuthContext);

  // section 21 stauts and data
  const [section21Data, setSection21Data] = useState(null);

  // message and taost notification
  const [toastPop, setToastPop] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // this is the section 21 fields needed for application
  const [title, setTitle] = useState("");
  const [fullName, setFullName] = useState("");
  const [surname, setSurname] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [occupation, setOccupation] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [weight, setWeight] = useState("");
  const [heightInCm, setHeightInCm] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [cellNumber, setCellNumber] = useState("");
  const [alternateNumber, setAlternateNumber] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [diagnosis, setDiagnosis] = useState("");
  const [treatmentDetails, setTreatmentDetails] = useState("");
  const [otherConditions, setOtherConditions] = useState("");
  const [doYouSmokeCannabis, setDoYouSmokeCannabis] = useState("");
  const [anyOtherForm, setAnyOtherform] = useState("");
  const [specify, setSpecify] = useState("");

  const [currentStatus, setCurrentStatus] = useState(
    "PENDING APPLICATION REVIEW"
  );
  const [validUntil, setValidUntil] = useState(null);

  // store selection variable

  const [allStores, setAllStores] = useState([]);
  const [store, setStore] = useState(null);
  const [storeOpen, setStoreOpen] = useState(false);

  // get stores info

  const getStores = async () => {
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/facilities/getFacilities",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
        }
      );

      const respnseData = await response.json();
      if (respnseData.store) {
        setAllStores(respnseData.store);
      }
    } catch (err) {
      setErrorMessage(
        "Unable to resgister account, some of the information provided is already in our system" +
          " " +
          err
      );
      setToastPop(true);
    }
  };

  // request section 21 and prescription
  const requestSection21 = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/requestPrescriptionUser/createSection21Request",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            idDoc: auth.customerUserData.idDoc,

            patientId: auth.customerUserData.idDoc,
            patientUserId: auth.customerUserData.userId,
            requestReason: diagnosis,
            email: auth.customerUserData.email,

            createdOn: new Date().toLocaleString(),
            title,
            fullNames: fullName,
            surname,
            idNumber,
            occupation,
            age,
            gender,
            weightInKg: weight,
            heightInCm,
            address,
            postalCode,
            cellNumber,
            alternateNumber,
            emailAddress,
            diagnosis,
            treatmentDetails,
            otherConditions,
            doYouSmokeCannabis,
            anyOtherWays: anyOtherForm,
            specify,
            // store collection point
            storeName: store.storeName,
            storeAddress:
              store.unitNumber +
              ", " +
              store.streetAddress +
              ", " +
              store.city +
              ", " +
              store.postalCode +
              ", " +
              store.province,
            storeId: store.storeId,
            // doctor and user ids
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setMessage("You request has been sent");
        setLoading(false);
        setSelectedSection("none");
        setToastPop(true);
      } else {
        setMessage(respnseData.message);
        setTimeout(() => {
          setLoading(false);
          setToastPop(true);
        }, 1000);
      }
    } catch (err) {
      // setRegistration(false);
      // setDisplayButtons(true);
      setMessage(
        "Unable to request section 21 some data is missing please check that all fields are filled"
      );
      setTimeout(() => {
        setLoading(false);
        setToastPop(true);
      }, 3000);
      console.log("error", err);
    }
  };

  // check for section 21 and stauts as well as prescription statuts and avaliblity
  const checkForSection21andPrescriptionStatus = async () => {
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/requestPrescriptionUser/getSection21ForPatientAndPrescriptions",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            patientId: auth.customerUserData.idDoc,
            patientUserId: auth.customerUserData.userId,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setSection21Data(respnseData.section21);
      } else {
        setMessage(respnseData.message);

        setToastPop(true);
      }
    } catch (err) {
      // setRegistration(false);
      // setDisplayButtons(true);
      setMessage("Unable to request prescription");
      setTimeout(() => {
        setToastPop(true);
      }, 3000);
      console.log("error", err);
    }
  };

  useEffect(() => {
    getStores();
    fetch(
      "https://budloungedatabase.onrender.com/medicalHistory/getMedicalHistoryByUser",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: auth.customerUserData.idDoc,
        }),
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setData(resData.lifestyleData);
      });
  }, []);

  useEffect(() => {
    if (data) {
      data.map(
        (section) => section.section === "lifestyle" && setLifeStyle(true)
      );
      data.map(
        (section) =>
          section.section === "lifestyle" && setLifeStyleInfo(section)
      );
    }
    if (data) {
      data.map(
        (section) =>
          section.section === "medical history" && setMedicalHistory(true)
      );
      data.map(
        (section) =>
          section.section === "medical history" && setMedicalInfo(section)
      );
    }
    if (data) {
      data.map(
        (section) =>
          section.section === "occupational" && setOccupationalDetails(true)
      );
      data.map(
        (section) =>
          section.section === "occupational" && setOccupationalInfo(section)
      );
    }
    if (data)
      data.map((section) => section.section === "consent" && setConsent(true));
  }, [data]);

  useEffect(() => {
    if (auth) {
      checkForSection21andPrescriptionStatus();
    }
  }, []);

  useEffect(() => {
    if (section21Data) {
      setTitle(section21Data.title);
      setFullName(section21Data.fullNames);
      setSurname(section21Data.surname);
      setIdNumber(section21Data.idNumber);
      setOccupation(section21Data.occupation);
      setAge(section21Data.age);
      setGender(section21Data.gender);
      setWeight(section21Data.weightInKg);
      setHeightInCm(section21Data.heightInCm);
      setAddress(section21Data.address);
      setPostalCode(section21Data.postalCode);
      setCellNumber(section21Data.cellNumber);
      setAlternateNumber(section21Data.alternateNumber);
      setEmailAddress(section21Data.emailAddress);
      setDiagnosis(section21Data.diagnosis);
      setOtherConditions(section21Data.otherConditions);
      setTreatmentDetails(section21Data.treatmentDetails);
      setDoYouSmokeCannabis(section21Data.doYouSmokeCannabis);
      setAnyOtherform(section21Data.anyOtherWays);
      setSpecify(section21Data.specify);
      setCurrentStatus(section21Data.status);
      setStore({
        storeName: section21Data.storeName,
      });
      if (section21Data.validUntil) {
        setValidUntil(section21Data.validUntil);
      }
    }
  }, [section21Data]);
  useEffect(() => {
    if (toastPop) {
      setTimeout(() => {
        setToastPop(false);
      }, 5000);
    }
  }, [toastPop]);
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {section === "none" ? (
        <>
          <div
            style={{
              width: "80%",
              textAlign: "center",
              fontSize: height > 550 ? null : 10,
              marginTop: 40,
            }}
          >
            Update your profile and apply for your Section 21 today, meet our
            consulting doctors and get your prescriptions
          </div>
          <div style={{ minHeight: 40 }} />
          {section21Data ? (
            <>
              <QuestionButton
                backgroundColor={"#2E933Ccc"}
                backgroundColorAlt={"#2E933Ccc"}
                // borderRadius={200}
                width={"80%"}
                height={60}
                title={"Section 21 application"}
                complete={true}
                borderOn={true}
                color={BlackAndWhite.secondary}
                colorAlt={BlackAndWhite.secondary}
                questionAmount={true}
                icon={require("../../../../images/material-icons/medicalhistory.png")}
                onClick={
                  section21Data
                    ? () => setSelectedSection("medicalHistory")
                    : null
                }
              />
              <div
                style={{
                  width: "80%",
                  backgroundColor: BlackAndWhite.red,
                  color: BlackAndWhite.secondary,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: 30,
                  fontWeight: "bold",
                }}
              >
                STATUS : {section21Data.status}
              </div>
            </>
          ) : (
            <QuestionButton
              title={"Section 21 application"}
              backgroundColor={BlackAndWhite.primary}
              backgroundColorAlt={"#FFFFFF66"}
              color={BlackAndWhite.secondary}
              colorAlt={BlackAndWhite.primary}
              // borderRadius={200}
              width={"80%"}
              height={60}
              onClick={() => setSelectedSection("medicalHistory")}
              borderOn={true}
              questionAmount={true}
              icon={require("../../../../images/material-icons/medicalhistory.png")}
            />
          )}
          <div style={{ minHeight: 40 }} />
          {/* {consent ? (
            <QuestionButton
              backgroundColor={"#2E933Ccc"}
              backgroundColorAlt={"#2E933Ccc"}
              // borderRadius={200}
              width={"80%"}
              height={60}
              title={"Consent form"}
              complete={true}
              borderOn={true}
              color={BlackAndWhite.secondary}
              colorAlt={BlackAndWhite.secondary}
              questionAmount={true}
              icon={require("../../../../images/material-icons/consent.png")}
            />
          ) : (
            <QuestionButton
              title={"Consent form"}
              backgroundColor={BlackAndWhite.primary}
              backgroundColorAlt={"#FFFFFF66"}
              color={BlackAndWhite.secondary}
              colorAlt={BlackAndWhite.primary}
              // borderRadius={200}
              width={"80%"}
              height={60}
              onClick={() => setSelectedSection("consent")}
              questionAmount={true}
              icon={require("../../../../images/material-icons/consent.png")}
            />
          )} */}
        </>
      ) : null}

      {/* {section === "lifestyle" ? (
        <Lifestyle
          setSelectedSection={setSelectedSection}
          setLifeStyle={setLifeStyle}
          lifeStyleInfo={lifeStyleInfo}
          weight={
            lifeStyleInfo
              ? "WEIGHT" + " " + lifeStyleInfo.answer1 + " KG"
              : "loading"
          }
          height={
            lifeStyleInfo
              ? "HEIGHT" + " " + lifeStyleInfo.answer2 + "CM"
              : "loading"
          }
          answer3Complete={lifeStyleInfo ? lifeStyleInfo.answer3 : "loading"}
          answer4Complete={lifeStyleInfo ? lifeStyleInfo.answer4 : "loading"}
          answer5Complete={lifeStyleInfo ? lifeStyleInfo.answer5 : "loading"}
          answer6Complete={lifeStyleInfo ? lifeStyleInfo.answer6 : "loading"}
          answer7Complete={lifeStyleInfo ? lifeStyleInfo.answer7 : "loading"}
          answer8Complete={lifeStyleInfo ? lifeStyleInfo.answer8 : "loading"}
          answer9Complete={lifeStyleInfo ? lifeStyleInfo.answer9 : "loading"}
          answer10Complete={lifeStyleInfo ? lifeStyleInfo.answer10 : "loading"}
          answer11Complete={lifeStyleInfo ? lifeStyleInfo.answer11 : "loading"}
        />
      ) : null} */}
      {section === "medicalHistory" ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            overflowY: "scroll",
            overflowX: "hidden",
          }}
        >
          <div
            style={{
              width: "90%",
              fontWeight: "bold",
              fontSize: 20,
              marginLeft: 90,
              marginTop: 25,
            }}
          >
            Section 21 application
          </div>
          <div style={{ width: "90%", marginTop: 20 }}>
            1. Supporting Documents Required:
          </div>

          <div style={{ width: "90%" }}> • Copy of ID</div>

          <div style={{ width: "90%", marginTop: 20, fontWeight: "bold" }}>
            <TextInputField
              labelTitle={"Title"}
              invert={true}
              onChange={(event) => setTitle(event.target.value)}
              mini={true}
              size={"90%"}
              value={title}
              readOnly={section21Data}
            />
            <TextInputField
              labelTitle={"Full names"}
              invert={true}
              onChange={(event) => setFullName(event.target.value)}
              mini={true}
              size={"90%"}
              value={fullName}
              readOnly={section21Data}
            />
            <TextInputField
              labelTitle={"Surname"}
              invert={true}
              onChange={(event) => setSurname(event.target.value)}
              mini={true}
              size={"90%"}
              value={surname}
              readOnly={section21Data}
            />
            <TextInputField
              labelTitle={"Id number"}
              invert={true}
              onChange={(event) => setIdNumber(event.target.value)}
              mini={true}
              value={idNumber}
              size={"90%"}
              readOnly={section21Data}
            />
            <TextInputField
              labelTitle={"Occupation"}
              invert={true}
              onChange={(event) => setOccupation(event.target.value)}
              mini={true}
              size={"90%"}
              value={occupation}
              readOnly={section21Data}
            />
            <TextInputField
              labelTitle={"Age"}
              invert={true}
              onChange={(event) => setAge(event.target.value)}
              mini={true}
              size={"90%"}
              value={age}
              readOnly={section21Data}
            />
            <TextInputField
              labelTitle={"Gender"}
              invert={true}
              onChange={(event) => setGender(event.target.value)}
              mini={true}
              size={"90%"}
              value={gender}
              readOnly={section21Data}
            />
            <TextInputField
              labelTitle={"Weigth in Kg"}
              invert={true}
              onChange={(event) => setWeight(event.target.value)}
              mini={true}
              value={weight}
              size={"90%"}
              readOnly={section21Data}
            />
            <TextInputField
              labelTitle={"height in cm"}
              invert={true}
              onChange={(event) => setHeightInCm(event.target.value)}
              mini={true}
              size={"90%"}
              value={heightInCm}
              readOnly={section21Data}
            />
            <TextAreaInput
              labelTitle={"Address"}
              color={BlackAndWhite.primary}
              invert={true}
              onChange={(event) => setAddress(event.target.value)}
              mini={true}
              size={"90%"}
              value={address}
              readOnly={section21Data}
            />
            <TextInputField
              labelTitle={"Postal code"}
              invert={true}
              onChange={(event) => setPostalCode(event.target.value)}
              mini={true}
              size={"90%"}
              value={postalCode}
              readOnly={section21Data}
            />
            <TextInputField
              labelTitle={"Cell number"}
              invert={true}
              onChange={(event) => setCellNumber(event.target.value)}
              mini={true}
              size={"90%"}
              value={cellNumber}
              readOnly={section21Data}
            />
            <TextInputField
              labelTitle={"Alternate number"}
              invert={true}
              onChange={(event) => setAlternateNumber(event.target.value)}
              mini={true}
              size={"90%"}
              value={alternateNumber}
              readOnly={section21Data}
            />
            <TextInputField
              labelTitle={"Email address"}
              invert={true}
              onChange={(event) => setEmailAddress(event.target.value)}
              mini={true}
              size={"90%"}
              value={emailAddress}
              readOnly={section21Data}
            />
            <TextAreaInput
              labelTitle={
                "Diagnosis – Full description including severity, staging and prognosis where applicable: Example: Chronic Pain, Anxiety, Fibromyalgia etc.– Please give a full description."
              }
              color={BlackAndWhite.primary}
              invert={true}
              onChange={(event) => setDiagnosis(event.target.value)}
              mini={true}
              size={"90%"}
              value={diagnosis}
              readOnly={section21Data}
            />
            <TextAreaInput
              labelTitle={
                "Details of current treatment regimen for the abovediagnosis. Include medical, surgical and other treatment: Example: Aspirin, Ibuprofen, Naproxen, Serotonin and Norepinephrine."
              }
              color={BlackAndWhite.primary}
              invert={true}
              onChange={(event) => setTreatmentDetails(event.target.value)}
              mini={true}
              size={"90%"}
              value={treatmentDetails}
              readOnly={section21Data}
            />
            <TextAreaInput
              labelTitle={
                "Do you suffer from any other conditions not yet mentioned? If yes, please specify as well as current treatment. Example: High Blood Pressure, Cholesterol, Diabetes etc."
              }
              color={BlackAndWhite.primary}
              invert={true}
              onChange={(event) => setOtherConditions(event.target.value)}
              mini={true}
              size={"90%"}
              value={otherConditions}
              readOnly={section21Data}
            />
            <TextInputField
              labelTitle={"Do you smoke Cannabis?"}
              invert={true}
              onChange={(event) => setDoYouSmokeCannabis(event.target.value)}
              mini={true}
              size={"90%"}
              value={doYouSmokeCannabis}
              readOnly={section21Data}
            />
            <TextInputField
              labelTitle={"Do you use Cannabis in any other form?"}
              invert={true}
              onChange={(event) => setAnyOtherform(event.target.value)}
              mini={true}
              size={"90%"}
              value={anyOtherForm}
              readOnly={section21Data}
            />
            <TextInputField
              labelTitle={"Specify"}
              invert={true}
              onChange={(event) => setSpecify(event.target.value)}
              mini={true}
              size={"90%"}
              value={specify}
              readOnly={section21Data}
            />
            <div style={{ marginTop: 20 }}>Store Collection point request</div>

            <StoreSelector
              allStores={allStores}
              open={storeOpen}
              setStore={setStore}
              store={store}
              setStoreOPen={setStoreOpen}
              onStoreClick={() => setStoreOpen(true)}
            />

            {/* <TextInputField
              labelTitle={"Store Name"}
              invert={true}
              // onChange={(event) => setAnswer1(event.target.value)}
              mini={true}
              size={"90%"}
              value={store ? store.storeName : "loading"}
            /> */}
            <TextAreaInput
              readOnly={section21Data}
              labelTitle={"Store Address"}
              color={BlackAndWhite.primary}
              invert={true}
              // onChange={(event) => setAnswer1(event.target.value)}
              mini={true}
              value={
                section21Data
                  ? section21Data.storeAddress
                  : store
                  ? store.unitNumber +
                    " " +
                    store.streetAddress +
                    ", " +
                    store.suburb +
                    ", " +
                    store.city +
                    ", " +
                    store.postalCode
                  : "loading"
              }
              size={"90%"}
            />
            <div style={{ color: BlackAndWhite.primary, marginTop: 20 }}>
              Status
              <div style={{ marginTop: 5, fontWeight: "normal" }}>
                {currentStatus}
              </div>
            </div>
            <div style={{ marginTop: 20 }}>
              Valid Until
              <div style={{ marginTop: 5, fontWeight: "normal" }}>
                {validUntil ? validUntil : "pending review"}
              </div>
            </div>
            {/* <div style={{ minHeight: 20 }} /> */}
            {section21Data ? null : (
              <BaseButtons
                mini={true}
                label={"SUBMIT"}
                size={"100%"}
                onClick={() => requestSection21()}
              />
            )}
            <div style={{ minHeight: 20 }} />
          </div>
        </div>
      ) : null}
      {/* {section === "occupational" ? (
        <OccupationalInfo
          setOccupationalDetails={setOccupationalDetails}
          setSelectedSection={setSelectedSection}
          occupationaleInfo={occupationaleInfo}
          answer1Complete={
            occupationaleInfo ? occupationaleInfo.answer1 : "loading"
          }
          answer2Complete={
            occupationaleInfo ? occupationaleInfo.answer2 : "loading"
          }
        />
      ) : null} */}
      {section === "consent" ? (
        <Consent
          setSelectedSection={setSelectedSection}
          setConsent={setConsent}
        />
      ) : null}
      {section !== "none" ? (
        <div style={{ position: "fixed", top: 60, left: 20 }}>
          <CloseButton label={"X"} onClick={() => setSelectedSection("none")} />
        </div>
      ) : null}
      <LoadingPopUp display={loading} newWidth={"100%"} />
      <ToastNotification display={toastPop} message={message.toUpperCase()} />
    </div>
  );
};

export default MedicalHistory;
